import { Button, Icon, Popover, PopoverContent, PopoverTrigger } from "@elit-hair/elit-ui";
import { useTranslation } from "react-i18next";
import { TbHistory } from "react-icons/tb";

import { HeaderCallDialerContent } from "@/components/header/call-dialer-content";
import {
    HEADER_ACTION_BUTTON_CLASS,
    HEADER_LAST_CALL_POPOVER_CLASS,
} from "@/components/header/constants/header-controls";
import { HeaderCallDialerVariant } from "@/components/header/types/call-dialer.types";

export function HeaderLastCallPopover() {
    const { t } = useTranslation();

    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button className={HEADER_ACTION_BUTTON_CLASS} aria-label={t("last_call")}>
                    <Icon icon={TbHistory} />
                    <span className="hidden lg:inline">{t("last_call")}</span>
                </Button>
            </PopoverTrigger>
            <PopoverContent align="end" sideOffset={8} className={HEADER_LAST_CALL_POPOVER_CLASS}>
                <p className="mb-2 text-sm font-medium">{t("last_call")}</p>
                <HeaderCallDialerContent variant={HeaderCallDialerVariant.LAST_CALL} />
            </PopoverContent>
        </Popover>
    );
}
